import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

type BasicFieldInfoProps = {
  name: string;
  setName: (value: string) => void;
  type: "single_select" | "multi_select" | "nested_multi_select";
  setType: (value: "single_select" | "multi_select" | "nested_multi_select") => void;
};

export const BasicFieldInfo = ({ name, setName, type, setType }: BasicFieldInfoProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="name">Field Name</Label>
        <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required />
      </div>

      <div className="space-y-2">
        <Label htmlFor="type">Field Type</Label>
        <Select
          value={type}
          onValueChange={(value: "single_select" | "multi_select" | "nested_multi_select") => setType(value)}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="single_select">Single Select</SelectItem>
            <SelectItem value="multi_select">Multi Select</SelectItem>
            <SelectItem value="nested_multi_select">Nested Multi Select</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </>
  );
};
